import { ForgotPasswordRequest } from 'api/auth/types'
import { INVALID_EMAIL, REQUIRED } from 'utils/constants'
import { z } from 'zod'

const schema: z.ZodType<ForgotPasswordRequest> = z.lazy(() =>
  z.object({
    email: z.string().min(1, REQUIRED).email(INVALID_EMAIL),
  }),
)

export type FormProps = z.infer<typeof schema>

export default schema
